export default __webpack_public_path__ + "static/media/diner_1.67efb80b.mp4";